import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import PisCstService from "./pisCstService"
import FormList from 'base/FormList'

export default function PisCstList() {

    const [service] = useState(() => new PisCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_piscst',
        dsName: 'descricao_piscst',
        mainField: { name: 'descricao_piscst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_piscst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_piscst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_piscst" sortable header="Código"></Column>
            <Column field="descricao_piscst" sortable header="Descrição"></Column>
        </FormList >
    )
}
